<template>
  <div
    class="Contact"
    style="
      width: 100%;
      height: 100vh;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    "
  >
    <!-- Fixed Header Section -->
    <div>
      <b-container fluid style="padding-top: 100px">
        <b-row>
          <b-col cols="12" class="headerF"><HeaderFixed /></b-col>
          <b-col cols="12" class="headerM"><HeaderMobile /></b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-breadcrumb style="background-color: #e9ecef78">
              <b-breadcrumb-item>
                <router-link to="/">
                  <b-icon
                    icon="house-door"
                    scale="1.25"
                    shift-v="1.25"
                    aria-hidden="true"
                  />
                  Home
                </router-link>
              </b-breadcrumb-item>
              <b-breadcrumb-item active>Customer Care</b-breadcrumb-item>
            </b-breadcrumb>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <!-- Scrollable Content Section -->
    <div style="flex: 1; overflow-y: auto">
      <b-container fluid>
        <b-row class="justify-content-center">
          <b-col cols="12" md="10" lg="8">
            <div
              id="customerCare"
              style="
                background-color: #fff8e1;
                border: 1px solid #ffc107;
                padding: 1.5rem;
                border-radius: 10px;
                margin-top: 1rem;
              "
            >
              <div class="flyer" style="display: flex; align-items: flex-start">
                <img
                  src="../assets/call-center.png"
                  alt="Call Center"
                  style="width: 50px; height: 65px; margin-right: 4px"
                />

                <div style="line-height: 1.1; font-size: 16.5px">
                  <div>
                    Centralized Customer Care Number:
                    <strong style="color: #ffd700; font-size: 18px"
                      >1912</strong
                    >
                  </div>
                  <div>
                    কেন্দ্ৰীয় গ্ৰাহক সেৱা নম্বৰ:
                    <strong style="color: #ffd700">১৯১২</strong>
                  </div>
                </div>
              </div>

              <!-- Hidden for now — remove style="display:none" below to bring this back -->
              <div class="bill-flyer" style="display: none;">
                <div class="bill-flyer-head">
                  <span class="bill-flyer-icon">
                    <b-icon icon="phone-vibrate" font-scale="1.8"></b-icon>
                  </span>
                  <span class="bill-flyer-title-group">
                    <span class="bill-flyer-title"
                      >Know Your Postpaid Bill Instantly</span
                    >
                  </span>
                </div>

                <div class="bill-flyer-lang">
                  <p class="bill-flyer-line">
                    Type
                    <span class="bill-flyer-code"
                      >BILL &lt;space&gt; 12-digit consumer number</span
                    >
                    and send it to
                    <span class="bill-flyer-number">8424882488</span>
                  </p>
                </div>

                <div class="bill-flyer-divider"></div>
                <div class="bill-flyer-head">
                  <span class="bill-flyer-icon">
                    <b-icon icon="phone-vibrate" font-scale="1.2"></b-icon>
                  </span>
                  <span class="bill-flyer-title-group">
                    <span class="bill-flyer-title bill-flyer-title-as"
                      >তৎক্ষণাৎ আপোনাৰ পোষ্টপেইড বিল জানক</span
                    >
                  </span>
                </div>
                <div class="bill-flyer-lang">
                  <p class="bill-flyer-line">
                    <span class="bill-flyer-code"
                      >BILL &lt;ঠাই এৰি&gt; আপোনাৰ ১২ অংকৰ কনজিউমাৰ নম্বৰ</span
                    >
                    টাইপ কৰি
                    <span class="bill-flyer-number">৮৪২৪৮৮২৪৮৮</span> নম্বৰলৈ এছ
                    এম এছ কৰক
                  </p>
                </div>
              </div>

              <!-- English Section -->
              <b-row>
  <b-col cols="12">
    <h1 class="heading" style="color: #d84315; font-weight: bold">
      📞 APDCL Customer Care
    </h1>
  </b-col>
</b-row>

<p class="content" style="text-align: left; font-size: 1rem; color: #333">
  <strong>For any Complaint or Query:</strong>
</p>



<div class="contact-item">
  <img
    src="../assets/call-center.png"
    class="contact-icon-img"
    alt="Call Center"
  />

 

  <div class="contact-text" style="text-align:left;">
  <strong>Contact / Complaint Number:</strong>

  <div>
    <span style="color: #d32f2f; font-weight: bold">
      1912
    </span>
    <span style="font-size:14px">
      (Calls made from within Assam)
    </span>
  </div>

  <div style="white-space: nowrap;">
    <span style="color:#d32f2f; font-weight: bold">
      0361-3126201 / 0361-2803200
    </span>
    <span style="font-size:14px">
      (Calls made from outside Assam)
    </span>
  </div>
</div>

</div>



<div class="contact-item">
  <img
    src="../assets/whatsapp.png"
    class="contact-icon-img"
    alt="WhatsApp"
  />

  <div>
    <strong>WhatsApp Number:</strong>
    <span
      class="contactTextStyle"
      style="color: #388e3c; font-weight: bold"
    >
      7575999666
    </span>
  </div>
</div>


<div class="contact-item">
  <b-icon icon="envelope-fill" class="contact-icon" />

  <div>
    <strong>E-mail:</strong>
    <span
      class="contactTextStyle"
      style="color: #388e3c; font-weight: bold"
    >
      support@apdcl.org
    </span>
  </div>
</div>
<div class="contact-item">
  <b-icon icon="chat-fill" class="contact-icon" />

  <div>
    <strong>Virtual Mobile Number(VMN):</strong>
    <span
      class="contactTextStyle"
      style="color: #388e3c; font-weight: bold"
    >
      8424882488
    </span>

    <small
      style=" margin-left:0px; font-style: italic; color: #555;"
    >
      ( To Know Your Postpaid Bill Instantly Type:<br>
      
      <span  style=" margin-left:6px; color: #0d47a1; font-weight: bold;"
      >
        BILL &lt;&nbsp;   space   &gt; 12-digit consumer number
      </span>
      and send it to the above <strong>VMN **8424882488**</strong>.)
    </small>
    
  </div>
</div>



<div class="contact-item">
  <span class="contact-icon">▶</span>
  <div>
    <small
      style="
        display: block;
        margin-top: 0.5rem;
        font-style: italic;
        color: #555;
      "
    >
      For billing-related complaints, please provide your
      <span
        class="contactTextStyle"
        style="color: #0d47a1; font-weight: bold"
      >
        12-digit consumer number &amp; subdivision name
      </span>.
    </small>
  </div>

 
  </div>






              <!-- Assamese Section -->
               <hr>
               <div class="assamese-section">
                
                <b-row>
  <b-col cols="12">
    <h1 class="heading" style="color: #d84315; font-weight: bold">
      📞 এপিডিচিএলৰ গ্ৰাহক সেৱা
    </h1>
  </b-col>
</b-row>
<p class="content" style="text-align: left; font-size: 1rem; color: #333">
  <strong>যিকোনো অভিযোগ বা প্ৰশ্নৰ বাবে:</strong>
</p>

<div class="contact-item">
  <img
    src="../assets/call-center.png"
    class="contact-icon-img"
    alt="Call Center"
  />

 

  <div class="contact-text" style="text-align:left;">
  <strong>যোগাযোগ / অভিযোগ নম্বৰ:</strong>

  <div>
    <span style="color: #d32f2f; font-weight: bold">
      ১৯১২
    </span>
    <span style="font-size:14px">
     (অসমৰ পৰা অহা ফোন কলৰ বাবে) বা
    </span>
  </div>

  <div>
    <span style="color:#d32f2f; font-weight: bold">
      ০৩৬১–৩১২৬২০১ / ০৩৬১–২৮০৩২০০
    </span>
    <span style="font-size:14px">(অসমৰ বাহিৰৰ পৰা অহা ফোন কলৰ বাবে)
    </span>
  </div>
</div>

</div>


<div class="contact-item">
  <img
    src="../assets/whatsapp.png"
    class="contact-icon-img"
    alt="WhatsApp"
  />

  <div>
    <strong>হোৱাটছএপ নম্বৰ:</strong>
    <span
      class="contactTextStyle"
      style="color: #388e3c; font-weight: bold"
    >
      ৭৫৭৫৯৯৯৬৬৬
    </span>
  </div>
</div>


<div class="contact-item">
  <b-icon icon="envelope-fill" class="contact-icon" />

  <div>
    <strong>ই-মেইল:</strong>
    <span
      class="contactTextStyle"
      style="color: #388e3c; font-weight: bold"
    >
      support@apdcl.org
    </span>
  </div>
</div>
<div class="contact-item">
  <b-icon icon="chat-fill" class="contact-icon" />

  <div>
    <strong>ভাৰ্চুৱেল মোবাইল নম্বৰ (VMN):</strong>
    <span
      class="contactTextStyle"
      style="color: #388e3c; font-weight: bold"
    >
       ৮৪২৪৮৮২৪৮৮
    </span><small
      style="
     
       
        font-style: italic;
        color: #555;
      "
    >
     (আপোনাৰ পোষ্টপেইড বিল সম্পৰ্কে জানিবলৈ আৰু অনলাইন পৰিশোধ কৰিবলৈ::
      <span
        class="contactTextStyle"
        style="color: #0d47a1; font-weight: bold"
      >
     <br>   BILL &lt;    ঠাই এৰি    &gt; আপোনাৰ ১২ অংকৰ কনজিউমাৰ নম্বৰ
      </span>
     টাইপ কৰি ওপৰৰ <strong>VMN নম্বৰলৈ ** ৮৪২৪৮৮২৪৮৮** </strong>  এছ এম এছ কৰক।)
    </small>
    
  </div>
</div>


<div class="contact-item">
  <span class="contact-icon">▶</span>
  <div>
    <small
      style="
        display: block;
        margin-top: 0.5rem;
        font-style: italic;
        color: #555;
      "
    >
      বিলিং-সম্পৰ্কীয় অভিযোগৰ বাবে, অনুগ্ৰহ কৰি আপোনাৰ
      <span
        class="contactTextStyle"
        style="color: #0d47a1; font-weight: bold"
      >
        ১২ অংকৰ গ্ৰাহক নম্বৰ আৰু উপ-সংমণ্ডলৰ নাম
      </span>
      দিয়ক।
    </small>
  </div></div>
             

 
  </div>




              
            </div>
          </b-col>
          <br /><br /><br />
        </b-row>
        <br /><br /><br />
      </b-container>
    </div>
  </div>
</template>

<script>
import HeaderFixed from "@/components/HeaderFixed.vue";
import HeaderMobile from "@/components/HeaderMobile.vue";

export default {
  name: "Contact",
  components: {
    HeaderFixed: HeaderFixed,
    HeaderMobile: HeaderMobile,
  },
};
</script>

<style scoped="true">
li {
  padding: 0;
}

body {
  overflow-y: hidden;
}
.headerF {
  display: block;
}
.headerM {
  display: none;
}
.sideNav {
  height: 75vh;
  overflow-y: hidden;
}
.dropdownmenu {
  display: none;
}
.contact-item {
  display: flex;
  align-items: flex-start;
  margin: 2px 0;
}


.contact-icon {
  font-size: 1.25rem;
  color: #d84315;
  width: 28px;
  margin-right: 10px;
  margin-top: 2px;
  flex-shrink: 0;
}

.contact-icon-img {
  width: 24px;
  height: 24px;
  margin-right: 10px;
  margin-top: 2px;
  flex-shrink: 0;
}

.assamese-section {
  font-size: 14px;
}

.assamese-section .contact-item {
  font-size: 14px;
}

.assamese-section .contactTextStyle {
  font-size: 13px;
}
.flyer {
  font-family: Arial, sans-serif;
  max-width: 350px;
  background: #007bff;
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  float: right;
  margin: 0.8rem;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.bill-flyer {
  box-sizing: border-box;
  clear: right;
  float: right;
  width: 100%;
  max-width: 350px;
  margin: 0 0.8rem 0.8rem;
  padding: 12px 14px;
  border-radius: 8px;
  background: linear-gradient(135deg, #ffc107, #ff7043);
  box-shadow: 0 6px 18px rgba(255, 112, 67, 0.35);
  font-family: Arial, sans-serif;
  color: #3e1a00;
  text-align: left;
}

.bill-flyer-head {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;
}

.bill-flyer-icon {
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d84315;
  margin-top: 1px;
}

.bill-flyer-title-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.bill-flyer-title {
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.01em;
  color: #2b1200;
}

.bill-flyer-title-as {
  font-size: 12px;
  font-weight: 1100;
}

.bill-flyer-lang {
  margin: 0;
}

.bill-flyer-line {
  margin: 0;
  font-size: 11.5px;
  line-height: 1.45;
  color: #3e1a00;
  overflow-wrap: break-word;
  word-break: break-word;
}

.bill-flyer-divider {
  border-top: 1px solid rgba(62, 26, 0, 0.25);
  margin: 8px 0;
}

.bill-flyer-code {
  display: inline;
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid rgba(62, 26, 0, 0.25);
  border-radius: 4px;
  padding: 0px 4px;
  font-weight: 700;
  color: #2b1200;
  white-space: normal;
}

.bill-flyer-number {
  display: inline;
  background: #ffffff;
  border-radius: 4px;
  padding: 0px 5px;
  font-weight: 900;
  color: #c62828;
  letter-spacing: 0.02em;
}
@media (max-width: 768px) {
  .headerF {
    display: none;
  }
  .headerM {
    display: block;
  }
  .sideNav {
    /* height:50vh;
          overflow-y:hidden; */
    display: none;
  }
  .dropdownmenu {
    display: block;
  }

  .flyer {
    float: none;
    margin: 1rem auto;
  }

  .bill-flyer {
    clear: none;
    float: none;
    margin: 1rem auto;
  }
}
@media (max-width: 576px) {
  .sideNav {
    /* height:50vh;
          overflow-y:hidden; */
    display: none;
  }
  .dropdownmenu {
    display: block;
  }

  .flyer {
    width: 100%;
    max-width: 90%;
    margin: 1rem auto;
    font-size: 0.95rem;
  }

  .flyer strong {
    font-size: 1.3rem !important;
  }

  .bill-flyer {
    width: 100%;
    max-width: 92%;
    margin: 1rem auto;
  }

  .bill-flyer-line {
    font-size: 11px;
  }
}
</style>